/* =========================================================================
   Page titles: the browser tab reads "<title> · Codenec", and screen readers
   hear the title when the route changes (components/A11y/RouteAnnouncer.js).

   The first entry whose `match` fits the path wins. `match` is a React Router
   path pattern (case-insensitive, like the routes in App.js) or a RegExp.
   `key` is an i18n key. Paths with no entry get the plain "Codenec".
   A page can name itself instead with usePageTitle
   (components/A11y/pageTitle.js): lessons in the lesson hub use the lesson's
   own name, so "Lesson" below is only their fallback.
   ========================================================================= */

import { matchPath } from "react-router-dom";
import { ACCESSIBILITY_PATH, LEGAL_PATHS } from "config/legal";

// Every lesson id in App.js and the course registries: JS_M1_L5_1, V4_M2_L3, JS_M1_Q1...
const LESSON_ROUTE = /^\/(JS|CC|CD|V\d)_M\d+_[LQ]\d+(_\d+)?\/?$/i;

export const PAGE_TITLES = [
  { match: "/", key: "nav.home" },
  { match: "/landing-page11", key: "nav.home" },
  { match: "/login-page", key: "nav.login" },
  { match: "/register-page", key: "nav.register" },
  { match: "/register-to-plan", key: "nav.register" },
  { match: "/forgot-password", key: "pageTitles.forgotPassword" },
  { match: "/get-started", key: "landing.getStarted" },
  { match: "/contact", key: "footer.contactUs" },
  { match: "/contactus", key: "footer.support" },
  { match: "/subscriptions", key: "nav.pricing" },
  { match: "/courses", key: "nav.courses" },
  { match: "/javascript-table", key: "table.javascriptTableT" },
  { match: "/claudedev-table", key: "table.claudeDevTableT" },
  { match: "/claudedev-v2-table", key: "table.claudeDevV2TableT" },
  { match: "/claudedev-v3-table", key: "table.claudeDevV3TableT" },
  { match: "/claudedev-v4-table", key: "table.claudeDevV4TableT" },
  { match: LESSON_ROUTE, key: "lesson.lesson" },
  // Before /studio/*, which would match it too.
  { match: "/studio/plans", key: "studio.plans.pageTitle" },
  { match: "/studio/*", key: "nav.studio" },
  { match: "/accountsettings", key: "pageTitles.accountSettings" },
  { match: "/profile-page", key: "nav.Profile" },
  { match: "/resources", key: "resources.title" },
  { match: "/checkout/success", key: "pageTitles.checkoutSuccess" },
  { match: "/account-deleted", key: "deleteAccount.doneTitle" },
  { match: "/desktop-auth", key: "desktopAuth.eyebrow" },
  { match: LEGAL_PATHS.terms, key: "legal.links.terms" },
  { match: LEGAL_PATHS.privacy, key: "legal.links.privacy" },
  { match: LEGAL_PATHS.refunds, key: "legal.links.refunds" },
  { match: ACCESSIBILITY_PATH, key: "accessibilityPage.title" },
];

// The i18n key of the page title for `pathname`, or null.
export function pageTitleKey(pathname) {
  const entry = PAGE_TITLES.find(({ match }) =>
    match instanceof RegExp ? match.test(pathname) : matchPath(match, pathname) !== null
  );
  return entry ? entry.key : null;
}
